import apiClient from './axios';

export interface MemberRegisterRequest {
  memberId: string;
  password: string;
  nickname: string;
}

export interface MemberRegisterResponse {
  memberId: string;
  nickname: string;
  requiresApproval: boolean;
}

export interface PendingMember {
  memberId: string;
  nickname: string;
  memberCreateTime: string;
}

export interface Member {
  memberId: string;
  nickname: string;
  memberAuth: string;
  memberCreateTime: string;
  memberUpdateTime: string;
}

/**
 * 회원가입
 */
export const registerMember = async (data: MemberRegisterRequest) => {
  const response = await apiClient.post<{
    success: boolean;
    message: string;
    data: MemberRegisterResponse;
  }>('/api/members/register', data);
  return response.data;
};

/**
 * 닉네임 변경
 */
export const updateNickname = async (nickname: string) => {
  const response = await apiClient.put<{
    success: boolean;
    message: string;
    nickname: string;
  }>('/api/members/me/nickname', { nickname });
  return response.data;
};

/**
 * 가입 승인 대기 목록 조회 (관리자)
 */
export const getPendingMembers = async () => {
  const response = await apiClient.get<PendingMember[]>('/api/members/pending');
  return response.data;
};

/**
 * 회원 승인 (관리자)
 */
export const approveMember = async (memberId: string) => {
  const response = await apiClient.put<{
    success: boolean;
    message: string;
  }>(`/api/members/${memberId}/approve`);
  return response.data;
};

/**
 * 회원 삭제 (관리자)
 */
export const deleteMember = async (memberId: string) => {
  const response = await apiClient.delete<{
    success: boolean;
    message: string;
  }>(`/api/members/${memberId}`);
  return response.data;
};

/**
 * 전체 회원 목록 조회 (관리자)
 */
export const getAllMembers = async () => {
  const response = await apiClient.get<Member[]>('/api/members');
  return response.data;
};

/**
 * ID 중복 체크
 */
export const checkIdDuplicate = async (memberId: string) => {
  const response = await apiClient.get<{ available: boolean; memberId: string }>('/api/members/check-id-duplicate', {
    params: { memberId },
  });
  return response.data.available; // true면 사용 가능
};

/**
 * 닉네임 중복 체크
 */
export const checkNicknameDuplicate = async (nickname: string) => {
  const response = await apiClient.get<{ available: boolean; nickname: string }>('/api/members/check-nickname-duplicate', {
    params: { nickname },
  });
  return response.data.available; // true면 사용 가능
};
